import { render } from "./Drawer.vue?vue&type=template&id=c22a698a&scoped=true&ts=true"
import script from "./Drawer.vue?vue&type=script&lang=ts"
export * from "./Drawer.vue?vue&type=script&lang=ts"

import "./Drawer.vue?vue&type=style&index=0&id=c22a698a&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22a698a"]])

export default __exports__